// ⬇️ só acrescentei useRef (resto como estava)
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightLong } from "react-icons/fa6";
import file from '../../../Documents/file.pdf'
import logo from "../../../Assets/logo_header.png";
import * as S from "./styles";

export const MenuDesk = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false); // ⬅️ ADD
  const dropdownRef = useRef(null); // ⬅️ ADD
  const navigate = useNavigate();

  // ⬇️ mantenha como quiser; só tirei o link de "Soluções" e adicionei subItems
  const buttons = [
    { label: "Home", link: "/" },
    {
      label: "Soluções",
      subItems: [
        { label: "Bindinntech", link: "/solucoes/bindinntech" },
        { label: "Bindtrack", link: "/solucoes/bindtrack" },
        { label: "Fisioteraplay", link: "/solucoes/fisioteraplay" },
        { label: "Atendevet", link: "/solucoes/atendevet" },
        { label: "Whatsign", link: "/solucoes/whatsign" },
      ],
    },
    { label: "Cases", link: "/cases" },
    { label: "Quem Somos", link: "/quem-somos" },
    {
      label: "Política da Empresa",
      subItems: [
        { label: "Código de Conduta e Ética", link: "file" },
        { label: "Canal de Denúncias", link: "/canalDenuncia" },
      ],
    },
    { label: "Contato", link: "/contato" },
  ];

  // ⬇️ só ajustei para: se tiver subItems, abre/fecha o dropdown; senão navega (igual ao seu)
  const handleClick = (index) => {
    const btn = buttons[index];
    if (btn.subItems?.length) {
      setActiveIndex(index);
      setOpenDropdown((v) => !v);
    } else {
      navigate(btn.link);
      setActiveIndex(index);
    }
  };

  // ⬇️ seu reset de 5s continua igual
  useEffect(() => {
    if (activeIndex !== null) {
      const timer = setTimeout(() => {
        setActiveIndex(null);
        setOpenDropdown(false); // fecha junto
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [activeIndex]);

  // ⬇️ fechar dropdown ao clicar fora / ESC (isolado; não mexe em mais nada)
  useEffect(() => {
    const onClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(false);
      }
    };
    const onEsc = (e) => e.key === "Escape" && setOpenDropdown(false);
    document.addEventListener("mousedown", onClickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <S.Wrapper>
      <S.Logo onClick={() => navigate("/")}>
        <img src={logo} alt="Logo" />
      </S.Logo>

      <S.ButtonBox>
        {buttons.map((btn, i) => {
          const isSolutions = !!btn.subItems?.length;

          // ⬇️ NÃO troquei seu BtnMenu nem estilos; só envolvi "Soluções" com um wrapper inline
          const ButtonEl = (
            <S.BtnMenu
              active={activeIndex === i}
              key={i}
              onClick={() => handleClick(i)}
              aria-haspopup={isSolutions ? "menu" : undefined}
              aria-expanded={isSolutions ? openDropdown : undefined}
            >
              {btn.label}
            </S.BtnMenu>
          );

          if (!isSolutions) return ButtonEl;

          // ⬇️ para "Soluções": wrap inline + dropdown abaixo
          return (
            <S.DropWrap key={i} ref={dropdownRef}>
              {ButtonEl}
              {openDropdown && activeIndex === i && (
                <S.Dropdown
                  role="menu"
                  aria-label="Submenu de Soluções">
                  {btn.subItems.map((sub) =>
                    sub.label === "Código de Conduta e Ética" ? (
                      <S.DropLink
                        key={sub.label}
                        href={sub.link}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {sub.label}
                      </S.DropLink>
                    ) : (
                      <S.DropItem
                        key={sub.label}
                        role="menuitem"
                        tabIndex={0}
                        onClick={() => {
                          navigate(sub.link);
                          setOpenDropdown(false);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            navigate(sub.link);
                            setOpenDropdown(false);
                          }
                        }}
                      >
                        {sub.label}
                      </S.DropItem>
                    )
                  )}
                </S.Dropdown>
              )}
            </S.DropWrap>
          );
        })}
      </S.ButtonBox>

      <S.ActionBtn onClick={() => navigate("/contato")}>
        Fale com um especialista
        <FaArrowRightLong size={24} />
      </S.ActionBtn>
    </S.Wrapper>
  );
};
